import {MI} from "../init";
import {GameConfig} from "../game/GameConfig";

/**
 * @constructor
 * @extends {PreinfoSlide}
 */
import {PreinfoSlide} from "./PreinfoSlide";
import {ServerCfg} from "../ServerCfg";
import {ReelPrinter} from "../reel/ReelPrinter";
import {SpinReels} from "../reel/SpinReels";
import {ReelsSpinner} from "../reel/ReelsSpinner";
import {CONFIG_PARAMS} from "../../framework/src/system/SystemConfig";
import {systemConfig} from "../../framework/src/engine/madnes/madnes_variables";

export function PreinfoMultiplier() {
	PreinfoSlide.call(this);

	this._initMatrix = [
		[3, 0, 2],
		[4, 4, 5],
		[2, 7, 10],
		[1, 1, 2],
		[2, 6, 3]
	];
};

PreinfoMultiplier.prototype = Object.create(PreinfoSlide.prototype);
PreinfoMultiplier.prototype.constructor = PreinfoMultiplier;

PreinfoMultiplier.prototype._getGameConfig = function() {

	var gameCfg = new GameConfig();
	var y = 195;

	gameCfg.symbolHeight = 105;
	gameCfg.reelsPositions = [
		{ 'x': 91, 'y': y },
		{ 'x': 205, 'y': y },
		{ 'x': 322, 'y': y },
		{ 'x': 438, 'y': y },
		{ 'x': 555, 'y': y }
	];

	gameCfg.symbolOffsetY = 0;

	return gameCfg;
};

PreinfoMultiplier.prototype._getServerConfig = function() {

	var serverConfig = new ServerCfg();
	serverConfig.setServerConfig(MI.server.getConfig());
	serverConfig.setReelMatrix(this._initMatrix);

	return serverConfig;
};

/**
 * @param {SymbolsManager} symbolsManager
 * @param {MadnesGroup} symbolsGroup
 */
PreinfoMultiplier.prototype.create = function(symbolsManager, symbolsGroup) {

	if (systemConfig.get(CONFIG_PARAMS.LANGUAGE) === "es") {
		this._createBtns(320, 180, "multiplier_es");
	} else {
		this._createBtns(320, 180, "multiplier");
	}

	this._symbolsManager = symbolsManager;
	this._symbolsGroup = symbolsGroup;

	var gameConfig = this._getGameConfig();
	var reelPrinter = new ReelPrinter(gameConfig);

	this._serverConfig = this._getServerConfig();

	this._spinReels = new SpinReels();
//	this._spinReels.reelsSymbolsCount = 5;
	this._spinReels.init(reelPrinter, gameConfig, this._serverConfig, this._symbolsManager);

	this._spinReels.setSymbolsGroup(this._symbolsGroup);
	this._spinReels.setSymbolsScale(0.5);
	this._spinReels.setServerReels(this._getServerReels());
	this._spinReels.createReels();

	this._reelsSpinner = new ReelsSpinner(this._spinReels);
};

PreinfoMultiplier.prototype.run = function() {

	if(this._animRunning || !this._reelsSpinner) {
		return;
	}

	this._animRunning = true;

	this.setActive(true);

//	console.time('t');

	this._reelsSpinner.spin().then(this._reelsStop.bind(this));

	this._spinReels.prepareResult([
		[9, 8, 2],
		[2, 10, 11],
		[5, 10, 3],
		[0, 10, 6],
		[4, 10, 7]
	]);

	this._stopSpin();
};

PreinfoMultiplier.prototype._reelsStop = function() {

	if(!this._reelsSpinner) {
		return;
	}

	var _self = this;

	var positions = [[0, 1], [1, 1], [2, 1], [3, 1], [4, 1]];

	var resSymbols = this._spinReels.getResSymbols(positions);

	this._playWinAnim(resSymbols, 16).then(function() {

		if(!_self._reelsSpinner) {
			return;
		}

		_self._reelsRestart();
	});
};

PreinfoMultiplier.prototype._reelsRestart = function() {

	var _self = this;

	if(!_self._reelsSpinner) {
		return;
	}


//
//	this._reelsSpinner.spin().then(function() {
		_self._unsetActive();
		_self._animRunning = false;
//	console.timeEnd('t');
//	});
//	this._spinReels.prepareResult(this._serverConfig.getReelMatrix());
//	this._stopSpin();
};

/** @param {boolean} anim */
PreinfoMultiplier.prototype.setActive = function(anim) {

	this._btnShine.setVisible(true);

	if (systemConfig.get(CONFIG_PARAMS.LANGUAGE) === "es") {
		this._btn.setFrameName("multiplier_es_active");
	} else {
		this._btn.setFrameName("multiplier_active");
	}

	anim && this._setBtnActive();
};

PreinfoMultiplier.prototype._unsetActive = function() {
	if (systemConfig.get(CONFIG_PARAMS.LANGUAGE) === "es") {
		this._btn.setFrameName("multiplier_es");
	} else {
		this._btn.setFrameName("multiplier");
	}
};

PreinfoMultiplier.prototype.destroy = function() {

	this._destroyAnims();

	this._stopBtnTween();
	this._destroyBtns();

	this._symbolsManager = null;
	this._reelsSpinner = null;

	this._spinReels.destroy();
};